import React from 'react';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import { agentActionsModel } from '../../../api';
import { SearchBox } from '../../../UiKit';
import './AddInstructions.scss';
import PropTypes from 'prop-types';
import Button from '../../ComponentsV1/Button';
import toast from 'react-hot-toast';
import { Plus } from 'lucide-react';

export default class AddInstructions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddBtn: true,
      inputText: '',
      newInstruction: this.props.oldInstruction || '',
      showInputError: false,
      inputErrorText: '',
      isActive: false,
      isDisabled: false,
    };
    this.timerId = null;
    this.newInstructTimerId = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerId);
    clearTimeout(this.newInstructTimerId);
  };

  editInstruction = (event) => {
    this.setState({
      showInputError: false,
      newInstruction: event.target.value,
      isActive: event?.target?.value?.length ? true : false,
    });
  };

  saveInstruction = () => {
    const {
      orderId,
      target,
      checkIfTextBoxIsOpen,
      isMxInstruction = false,
      submitNewInstruction = () => {},
      updateaInstruction = () => {},
    } = this.props;
    const { newInstruction, isDisabled } = this.state;
    const data = {};
    if (isDisabled) return;

    if (!newInstruction.length) {
      this.setState({
        showInputError: true,
        inputErrorText: 'Please Enter some Instruction.',
      });
      return;
    }

    this.setState({
      isDisabled: true,
    });

    data['order_id'] = orderId;
    if (isMxInstruction) {
      data['instruction'] = newInstruction;
      data['action'] = target;
    } else {
      data['text'] = newInstruction;
      data['target'] = target;
    }

    agentActionsModel
      .addSpecialInstructions(data, isMxInstruction)
      .then((res) => {
        if (!res || res?.isError) {
          toast.error(res?.message || 'Oops! something went wrong!');
          this.setState({
            isDisabled: false,
          });
          return;
        }
        !isMxInstruction && updateaInstruction();
        this.timerId = setTimeout(() => {
          toast.success(res.message || 'Added instruction successfully!');
          this.setState({
            showAddBtn: true,
            isDisabled: false,
          });
          checkIfTextBoxIsOpen(false);
          this.newInstructTimerId = setTimeout(() => {
            submitNewInstruction();
          }, 1000);
        }, 1000);
      })
      .catch(() => {
        toast.error('Oops! Something went wrong!');
        this.setState({
          isDisabled: false,
        });
      });
  };

  showTextBox = () => {
    const { checkIfTextBoxIsOpen, oldInstruction } = this.props;
    checkIfTextBoxIsOpen(true);
    this.setState({
      showAddBtn: false,
      newInstruction: oldInstruction || '',
    });
  };

  hideTextBox = () => {
    const { checkIfTextBoxIsOpen } = this.props;
    checkIfTextBoxIsOpen(false);
    this.setState({
      showAddBtn: true,
      newInstruction: '',
    });
  };

  getDropDownvalues = (options) => {
    if (!options?.length) return null;
    let values =
      options &&
      options.map((option) => {
        option['title'] = option.instruction;
        option['id'] = option.action;
        return option;
      });
    return values;
  };

  onDropdownSelect = (value) => {
    this.setState({
      newInstruction: value,
    });
  };

  render() {
    const { showAddBtn, newInstruction, isDisabled } = this.state;
    const { label, item = null, oldInstruction } = this.props;

    return (
      <div className='addInstruction'>
        {showAddBtn ? (
          <Button
            title={label}
            size='small'
            className='tw-font-medium tw-leading-none'
            onClick={this.showTextBox}
          />
        ) : (
          <OnClickOutside handleClickOutside={this.hideTextBox} width='100%'>
            <div className='tw-flex tw-gap-2 tw-w-full'>
              {item?.type === 'dropdown' && item.options ? (
                <SearchBox
                  result={this.getDropDownvalues(item.options)}
                  value={oldInstruction || ''}
                  placeholder={'Select...'}
                  menuHeight='30rem'
                  inputWidth='100%'
                  isMultiSelect={false}
                  onSelect={this.onDropdownSelect}
                />
              ) : (
                <input
                  placeholder='Enter new instruction'
                  className='tw-w-full tw-rounded-lg tw-border-solid tw-px-2 tw-border-[1px] tw-border-green-700 tw-text-[1.4rem] tw-font-regular'
                  value={newInstruction}
                  onChange={this.editInstruction}
                  maxLength={100}
                />
              )}
              <Button
                title='Add'
                size='small'
                onClick={this.saveInstruction}
                isDisabled={isDisabled}
              />
            </div>
          </OnClickOutside>
        )}
      </div>
    );
  }
}

AddInstructions.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
};

AddInstructions.defaultProps = {
  label: (
    <div className='tw-flex tw-items-center tw-leading-none tw-gap-2'>
      <Plus size={18} strokeWidth={2.2} />
      Add Instruction
    </div>
  ),
};
